module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    attrs: {
      "id": "app"
    }
  }, [_h('NavBar'), " ", _h('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_h('router-view')])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e8b558d6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 58
// module chunks = 1